module.exports = __webpack_public_path__ + "img/ic_wechat1.97c79bd5.svg";